import { Glue42 } from "../../glue";
import { CallbackRegistry } from "callback-registry";
import { LayoutsLibConfiguration } from "./types";

const SaveContextMethodName = "T42.HC.GetSaveContext";
declare let htmlContainer: any;

/**
 * Logic for apps that want to provide custom context on save
 */
export default class ContextProvider {

    private interop: Glue42.Interop.API;

    constructor(private config: LayoutsLibConfiguration, private activitiesGetter: () => Glue42.Activities.API, private callbacks: CallbackRegistry, private logger: Glue42.Logger.API) {
        this.interop = config.agm;
        this.registerRequestMethods();
    }

    public onSaveRequested(callback: (info?: Glue42.Layouts.SaveRequestContext) => Glue42.Layouts.SaveRequestResponse) {
        return this.callbacks.add("saveRequested", callback);
    }

    private isActivityOwner() {
        // fallback for GD2 - remove once the bellow code is tested
        if (typeof htmlContainer !== "undefined") {
            const context = htmlContainer.getContext();
            return context && context._t42 && context._t42.activityIsOwner;
        }

        // check if we're the activity owners
        const activities = this.activitiesGetter();
        if (!activities) {
            return false;
        }

        if (!activities.inActivity) {
            return false;
        }

        const myWindow = activities.my.window;
        const myActivity = activities.my.activity;

        if (!myActivity && !myWindow) {
            return false;
        }

        return myActivity.owner.id === myWindow.id;
    }

    private registerRequestMethods() {
        this.interop.register<Glue42.Layouts.SaveRequestContext>(SaveContextMethodName, (args) => {
            const usersCbs = this.callbacks.execute("saveRequested", args);
            if (usersCbs?.length > 1) {
                this.logger.warn(`Multiple subscriptions for "glue.layouts.onSaveRequested" - only the first one will be used`);
            }
            const requestResult = usersCbs[0] as Glue42.Layouts.SaveRequestResponse;
            const autoSaveWindowContext = this.config.autoSaveWindowContext;

            if (typeof autoSaveWindowContext === "boolean" && autoSaveWindowContext) {
                return { autoSaveWindowContext };
            } else if (Array.isArray(autoSaveWindowContext) && autoSaveWindowContext.length > 0) {
                return { autoSaveWindowContext };
            }
            // always include the window context
            const result: Glue42.Layouts.SaveRequestResponse = { windowContext: requestResult?.windowContext, activityContext: undefined };

            // if we're the activity owner put the context too
            if (this.isActivityOwner()) {
                result.activityContext = requestResult?.activityContext;
            }

            return result;
        });
    }
}
